import { useState } from 'react';

import { useGetMyDetails } from '../../../../redux/api/users/usersApi';

export function useUserInfoViewComponent() {
  const { data: user } = useGetMyDetails();

  const [avatar, setAvatar] = useState(null);

  return {
    user,
    avatar,
    setAvatar,
  };
}
